import { tr } from "./language";
export const CONTACT_INFO_ERROR =
  tr("Phone numbers and email addresses are not allowed in product text fields.");

const EMAIL_RE = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
const PHONE_RE = /(^|[^\w])(?:\+?\d[\d\s().-]{6,}\d)(?=$|[^\w])/;

export const containsContactInfo = (value) => {
  const text = String(value || "");
  return EMAIL_RE.test(text) || PHONE_RE.test(text);
};

const firstContactInfoIndex = (values = []) =>
  values.findIndex((value) => containsContactInfo(value));

export const productBasicsContactErrors = (data = {}) => {
  const errors = {};

  [
    "title",
    "reference_code",
    "primary_city",
    "short_description",
    "full_description",
    "inclusions_other",
    "not_included_other",
    "guest_must_know",
  ].forEach((field) => {
    if (containsContactInfo(data[field])) errors[field] = CONTACT_INFO_ERROR;
  });

  const highlightsIndex = firstContactInfoIndex(data.highlights);
  if (highlightsIndex >= 0) {
    const highlightErrors = Array.from({ length: 3 }, (_, index) =>
      index === highlightsIndex ? CONTACT_INFO_ERROR : null,
    );
    errors.highlights = CONTACT_INFO_ERROR;
    errors.highlights_list = highlightErrors;
  }

  [
    "visit_locations",
    "keywords",
    "meals",
    "transports",
    "not_suitable_for",
    "suitability_tags",
  ].forEach((field) => {
    if (firstContactInfoIndex(data[field]) >= 0) errors[field] = CONTACT_INFO_ERROR;
  });

  return errors;
};

export const optionContactErrors = (option = {}) => {
  const errors = {};

  [
    "name",
    "reference_code",
    "languages_other",
    "meeting_point_location",
    "meeting_point_description",
    "pickup_area_description",
  ].forEach((field) => {
    if (containsContactInfo(option[field])) errors[field] = CONTACT_INFO_ERROR;
  });

  return errors;
};
